import { Flex } from '@/components/base';
import TagSelector from '@/features/Feedback/field/Tag/TagSelector';
import useUserRole from '@/hooks/domain/useUserRole';
import useFeedbackListStore from '@/stores/Feedback/FeedbackListStore';
import useTagStore from '@/stores/TagStore';
import { isEmptyArray } from '@/utils/util';

import { useFeedbackDetailContext } from '../../context/FeedbackDetailContext';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const TagField = (
  props: CommonFieldProps & {
    feedback_alias: string;
    labels?: string[];
    showFull?: boolean;
    setShowFull?: (showFull: boolean) => void;
  },
) => {
  const tagMap = useTagStore((state) => state.tagMap);
  const { updateDetail } = useFeedbackDetailContext();
  const { isEditor } = useUserRole();
  const isEditable = !props.isStatic && isEditor;
  const toggleTag = useFeedbackListStore((state) => state.toggleTag);

  const onToggleTag = (tagKey: string) => {
    const isSelected = props.labels?.includes(tagKey);
    toggleTag(props.feedback_alias, tagKey, isSelected ? 'remove' : 'add');
    if (isSelected) {
      updateDetail({
        labels: props.labels?.filter((l) => l !== tagKey),
      });
    } else {
      updateDetail({
        labels: [...(props.labels || []), tagKey],
      });
    }
  };

  if (!props.showFull && isEmptyArray(props.labels)) return null;

  return (
    <PropertyRowWrapper {...props} expandable>
      <Flex f={1}>
        <TagSelector
          name={`feedback-detail-${props.feedback_alias}-tags-standalone-dropdown`}
          selectedTags={props.labels
            ?.map((l) => tagMap[l]?.alias)
            .filter((l) => l)}
          toggleItem={onToggleTag}
          showFull={props.showFull}
          isEditable={isEditable}
          setShowFull={props.setShowFull}
        />
      </Flex>
    </PropertyRowWrapper>
  );
};
